import React,
{
  lazy,
  Suspense,
} from 'react'
import clsx from 'clsx'
import * as uuid from 'uuid'
import moment from 'moment'

const defaultSetting = {
  timePicker: true,
  startDate: new Date(),
  endDate: new Date(),
  locate: {format: 'M/D hh:mm A'},
}

const BootstrapDateRangePicker = lazy(() => {
  import('bootstrap-daterangepicker/daterangepicker.css')
  return import('react-bootstrap-daterangepicker')
})

const DateRangePicker = ({
  className,
  setting = {},
  onApply,
  dateDisplayFormat = 'DD MMM YYYY',
  children,
}) => {
  
  const id = uuid.v4()

  const now = moment()
  const todayStart = now.clone().startOf('day')
  const todayEnd = now.clone().endOf('day')

  const startOfFinancialYear = () => {
    const currentMonth = now.month() // 0-11
    const year =
      currentMonth >= 6
        ? now.year()
        : now.year() - 1

    return moment({
      year,
      month: 6, // July
      day: 1,
    }).startOf('day')
  }

  const presetRanges = {
    'Today': [todayStart, todayEnd],
    'Last 7 Days': [
      now.clone().subtract(6, 'days').startOf('day'),
      todayEnd,
    ],
    'Current Month': [
      now.clone().startOf('month'),
      now.clone().endOf('month'),
    ],
    'Current Quarter': [
      now.clone().startOf('quarter'),
      now.clone().endOf('quarter'),
    ],
    'Last 6 Months': [
      now.clone().subtract(5, 'months').startOf('month'),
      now.clone().endOf('month'),
    ],
    'Year to Date': [
      now.clone().startOf('year'),
      todayEnd,
    ],
    'Financial Year to Date': [
      startOfFinancialYear(),
      todayEnd,
    ],
  }

  return (
    <div id={ id } className={clsx('date-picker', className)}>
      <Suspense
        fallback={children}
      >
        <BootstrapDateRangePicker
          initialSettings={{
            ...defaultSetting,
            ranges: presetRanges,
            ...setting,
            locale: {
              format: dateDisplayFormat ? dateDisplayFormat : 'DD MMM YYYY',
            },
            parentEl: `#${id}`,
          }}
          dateDisplayFormat={dateDisplayFormat}
          onApply={onApply}
        >
          {children}
        </BootstrapDateRangePicker>
      </Suspense>
    </div>
  )
}

export default DateRangePicker
